import { AppSmtp } from "./appSmtp.model";
import { BaseModel } from "./base/base.model";

export class AppEmpresas extends BaseModel {
  company1?: string;
  companyCode?: number;
  appId?: string;
  myreportin?: string;
  name?: String;
  enabled?: boolean;
  netUsers?: any[];
  hrValidators?: any[];
  holidayBagValidator?: String;
  HRValidatorName?: String;
  pushAcceptText?: String;
  pushDenyText?: String;
  mailAcceptText?: String;
  mailDenyText?: String;
  image?: string;
  stamp?: string;
  companyImageData?: { name: string; mimeType: string; base64: string; base64FullData: string };
  companyStampData?: { name: string; mimeType: string; base64: string; base64FullData: string };
  customRedirection: {
    redirectionId: string;
    name: string;
    image: string;
    androidUrl: string;
    iosUrl: string;
    createdAt?: Date;
    modifiedOn?: Date;
    showButtonRedirection: boolean;
    imageDefault: string;
  };
  holidayBagAllowed?: boolean;
  sendAutoInvite?: boolean;
  advanceAllowed?: boolean;
  advanceInitialDay?: number;
  advanceLimitDay?: number;
  advanceLimitAmount?: number;
  advanceValidator?: string;
  advanceValidatorData?: { hrValidator1?: string; hostelUserId: string; email: string; name: string; surname: string; userName: string; enabled: boolean };
  validatorId?: string;
  delegateResponsible?: String;
  dualResponsible?: String;
  delegateResponsibleAllow?: string;
  dualResponsibleAllow?: string;
  seniorityCompanyDate?: boolean;
  smtpServerData?: Partial<AppSmtp>;
  identifierNumber?: string;
  workCentersAmount?: Number;
}
